<template>
    <div>
        <div v-for="(item,index) in ifilter" :key="index" style="margin-top:10px;margin-bottom:20px">
            {{item}}
        </div>
        <el-row>
          <el-col :span="8" v-for="(item,index) in filterCards" :key="index">
            <el-card style="height: 620px" shadow="hover">
              <div slot="header" v-html="item.name"></div>
              <p v-for="(subItem,index2) in item.desc" :key="index2">{{subItem}}</p>
            </el-card>
          </el-col>
        </el-row>
        <div style="margin-top: 30px">リンク集</div>
        <div class="linkContainer">
          <div>
            <a href="http://www.vector.co.jp/soft/winnt/util/se498053.html">Vector社検索ソフト集</a><br>
            <a href="http://download.seesaa.jp/contents/win/system/filer/16135/">Seesaa社検索ソフト集</a><br>
            <a href="http://download.goo.ne.jp/software/category/win/util/file/find/">Goo社検索ソフト集</a><br>
          </div>
          <div>
            <a href="http://ja.wikipedia.org/wiki/%E5%85%A8%E6%96%87%E6%A4%9C%E7%B4%A2#.E6.9C.89.E5.84.9F_2">Wikipediaー全文検索ソフト</a><br>
            <a href="http://download.nifty.com/download/win/util/file/find/">niftyー検索ソフト集</a><br>
            <a href="http://pdffreesoft.net/archives/pdf_search.html">厳選！ＰＤＦフリーソフト</a><br>
          </div>
          <div>
            <a href="http://www.altech-ads.com/product/10008348.htm">World Soft</a><br>
            <a href="http://ansinsoft.com/">安心ソフト</a><br>
          </div>
        </div>
      </div>
</template>

<script>
export default {
  data: function () {
    return {
      ifilter: [
        'V2.8.2から全文検索くん（Search++）はマイクロソフト社IFILTERのインタフェースをサポートしました。',
        'Windows XP, Windows Vista, Windows7 32Bit,　Windows7　64Bit, Windows 8, Windows 10環境で下記各社の製品へのインタフェースが実装して、正しく動作することを確認できました。',
        'IFILTER製品自体は各社の使用条件を確認したうえで、ダウンロードしてのご利用をお願いします、IFILTER製品自体に対してこちらのサポート対象外です。よろしくお願いします。'
      ],
      filterCards: [
        {
          name: '<a href="http://www.adobe.com/support/downloads/detail.jsp?ftpID=2611" target="blank">【縦書きPDF】</a>',
          desc: [
            '１）まず、PDFに対してIFILTERを使用するように、設定ファイル（Config.xml）に一行を追加します、',
            '<IFilter.pdf>1</IFilter.pdf>',
            '（全文検索くんは実行中の場合、設定を変更する前に、全文検索くんを停止させる必要です）',
            '２）Windows Vista, Windows 7, Windows 8では上記リンクからソフトウェアをダウンロードして、インストールして、インデックス作成すれば、検索できるようになります。',
            '縦書きPDFをサポートする場合、インデックス作成時間がかかる場合はありますので、あらかじめご了承してください。'
          ]
        },
        {
          name: '<a href="http://www.justsystems.com/jp/download/ichitaro/ifilter/" target="blank">【一太郎】</a>',
          desc: [
            '一太郎13（試用版、正式版関係なく）をインストールした場合、IFILTERも同時インストールされます。ですので、一太郎13がインストールしていたPCに対して、別途上記Content Filterをインストール必要ありません。',
            '32ビットIFILTERですが、64ビットOSでもご利用可能です。'
          ]
        },
        {
          name: '<a href="http://www.fujixerox.co.jp/download/software/docuworks_7/download206/" target="blank">【Docuwork】</a>',
          desc: [
            'Docuworks　8.0の場合、DocuWorks 8をインストールすると、同時にDocuWorks Content Filter 8もインストールされます。',
            'ですので、Docuworks　8.0がインストールしてあるPCに対して、別途Content Filterをインストール必要ありません。'
          ]
        }
      ]
    }
  }
}
</script>

<style scoped>
.linkContainer {
  width: 100%;
  display: flex;
  /* flew-direction: row */
  text-align: center;
}

.linkContainer>div{
  flex: 1;
}

.linkContainer>div>a{
  display: inline-block;
  margin-top: 10px;
}
</style>
